import Features from './Features';
export const _marketingFreeFeatureIds = {
  [Features.ALL_CRM_FEATURES]: {},
  [Features.FORMS]: {},
  [Features.EMAIL_MARKETING]: {},
  [Features.AD_MANAGEMENT]: {},
  [Features.LANDING_PAGES]: {},
  [Features.CONVERSATIONS_INBOX]: {},
  [Features.LIST_SEGMENTATION]: {},
  [Features.TEAM_EMAIL]: {},
  [Features.LIVE_CHAT]: {},
  [Features.CONVERSATIONAL_BOTS]: {},
  [Features.MOBILE_OPTIMIZATION]: {},
  [Features.REPORTING_DASHBOARDS]: {},
  [Features.MESSENGER_INTEGRATION]: {},
  [Features.CUSTOM_PROPERTIES]: {},
  [Features.MOBILE_APP]: {},
  [Features.MARKETING_EVENTS_OBJECT]: {},
  [Features.EMAIL_REPLY_TRACKING]: {},
  [Features.EMAIL_HEALTH_REPORTING]: {},
  [Features.AD_RETARGETING]: {},
  [Features.USER_MANAGEMENT]: {},
  [Features.CUSTOM_USER_PERMISSIONS]: {},
  [Features.EMAIL_AUTOMATION]: {},
  [Features.FORM_AUTOMATION]: {},
  [Features.SEO_RECOMMEND_OPTIMIZE]: {},
  [Features.BLOG]: {},
  [Features.SSL_CERTIFICATE]: {},
  [Features.WEBSITE_TRAFFIC_ANALYTICS]: {},
  [Features.MULTI_LANGUAGE_CREATION_TESTING]: {},
  [Features.SUBDOMAIN_AND_COUNTRY_CODE_TLD]: {}
};
export const _marketingStarterFeatureIds = Object.assign({}, _marketingFreeFeatureIds, {
  [Features.EMAIL_HEALTH_INSIGHTS]: {},
  [Features.MULTI_CURRENCY]: {},
  [Features.TECHNICAL_SUPPORT]: {},
  [Features.REQUIRED_FIELDS]: {},
  [Features.PAYMENTS]: {},
  [Features.EMAIL_SUPPORT]: {}
});
export const _marketingProfessionalFeatureIds = Object.assign({}, _marketingStarterFeatureIds, {
  [Features.CONTENT_STRATEGY]: {},
  [Features.GOOGLE_SEARCH_CONSOLE_INTEGRATION]: {},
  [Features.CALLS_TO_ACTION]: {},
  [Features.MULTI_LANGUAGE_CONTENT]: {},
  [Features.ABM_TOOLS_AND_AUTOMATION]: {},
  [Features.EMAIL_COMPARISON_REPORTING]: {},
  [Features.PRODUCTS]: {},
  [Features.ADS_OPTIMIZATION_EVENTS]: {},
  [Features.OMNI_CHANNEL_MARKETING_AUTOMATION]: {},
  [Features.ATTRIBUTION_REPORTING]: {},
  [Features.AB_TESTING]: {},
  [Features.VIDEO_HOSTING_MANAGEMENT]: {},
  [Features.TEAMS]: {},
  [Features.CUSTOM_REPORTS]: {},
  [Features.STANDARD_CONTACT_SCORING]: {},
  [Features.COMPANY_SCORING]: {},
  [Features.CAMPAIGN_REPORTING]: {},
  [Features.FILTERED_ANALYTICS_VIEW]: {},
  [Features.CALCULATED_PROPERTIES]: {},
  [Features.WEBSITE_TRAFFIC_ANALYTICS]: {},
  [Features.RECORD_CUSTOMIZATION]: {},
  [Features.TARGET_ACCOUNTS_HOME]: {},
  [Features.LOGGED_IN_VISITOR_IDENTIFICATION]: {},
  [Features.SOCIAL_MEDIA]: {},
  [Features.SALESFORCE_INTEGRATION]: {},
  [Features.DYNAMIC_PERSONALIZATION]: {},
  [Features.COLLABORATION_TOOLS]: {},
  [Features.EMAIL_HEALTH_REPORTING]: {},
  [Features.CAMPAIGN_MANAGEMENT]: {},
  [Features.DUPLICATE_MANAGEMENT]: {},
  [Features.PERMISSION_SETS]: {},
  [Features.ASSOCIATION_LABELS]: {},
  [Features.CUSTOM_VIEWS_SHARED_INBOX]: {},
  [Features.SEO_ANALYTICS]: {},
  [Features.WHATS_APP_INTEGRATION]: {},
  [Features.PRESETS]: {}
});
export const _marketingEnterpriseFeatureIds = Object.assign({}, _marketingProfessionalFeatureIds, {
  [Features.SALESFORCE_CUSTOM_OBJECT_SYNC]: {},
  [Features.CUSTOM_OBJECTS]: {},
  [Features.YOUTUBE_INTEGRATION]: {},
  [Features.HIERARCHICAL_TEAMS]: {},
  [Features.ADAPTIVE_TESTING]: {},
  [Features.BEHAVIORAL_EVENT_TRIGGERS]: {},
  [Features.PREDICTIVE_LEAD_SCORING]: {},
  [Features.SINGLE_SIGN_ON]: {},
  [Features.PARTITIONING]: {},
  [Features.MULTI_TOUCH_REVENUE_ATTRIBUTION]: {},
  [Features.FIELD_LEVEL_PERMISSIONS]: {},
  [Features.CUSTOM_BEHAVIORAL_EVENTS]: {},
  [Features.ADMIN_NOTIFICATIONS_MANAGEMENT]: {},
  [Features.HUBDB]: {},
  [Features.SANDBOXES]: {},
  [Features.LOGIN_AS_ANOTHER_USER]: {},
  [Features.CUSTOMER_JOURNEY_ANALYTICS]: {}
});
export const _salesFreeFeatureIds = {
  [Features.ALL_CRM_FEATURES]: {},
  [Features.LIVE_CHAT]: {},
  [Features.CONVERSATIONAL_BOTS]: {},
  [Features.TEAM_EMAIL]: {},
  [Features.QUOTES]: {},
  [Features.CALLING_SDK]: {},
  [Features.EMAIL_SCHEDULING]: {},
  [Features.EMAIL_TRACKING_NOTIFICATIONS]: {},
  [Features.CONVERSATIONS_INBOX]: {},
  [Features.SNIPPETS]: {},
  [Features.DOCUMENTS]: {},
  [Features.MEETINGS]: {},
  [Features.REPORTING_DASHBOARDS]: {},
  [Features.DEAL_PIPELINE]: {},
  [Features.MESSENGER_INTEGRATION]: {},
  [Features.CUSTOM_PROPERTIES]: {},
  [Features.MOBILE_APP]: {},
  [Features.MARKETING_EVENTS_OBJECT]: {},
  [Features.EMAIL_REPLY_TRACKING]: {},
  [Features.SLACK]: {},
  [Features.EMAIL_HEALTH_REPORTING]: {},
  [Features.ONE_TO_ONE_EMAIL]: {},
  [Features.USER_MANAGEMENT]: {},
  [Features.CUSTOM_USER_PERMISSIONS]: {},
  [Features.TEMPLATES]: {},
  [Features.CONTACT_WEBSITE_ACTIVITY]: {},
  [Features.GMAIL_AND_OUTLOOK_INTEGRATION]: {},
  [Features.HUBSPOT_CONNECT_INTEGRATIONS]: {},
  [Features.CUSTOM_SUPPORT_FORM_FIELDS]: {},
  [Features.PROSPECTS]: {},
  [Features.CONTACT_MANAGEMENT]: {},
  [Features.LIST_SEGMENTATION]: {}
};
export const _salesStarterFeatureIds = Object.assign({}, _salesFreeFeatureIds, {
  [Features.PAYMENTS]: {},
  [Features.GOALS]: {},
  [Features.MULTI_CURRENCY]: {},
  [Features.HS_PHONE_NUMBERS]: {},
  [Features.CALLING]: {},
  [Features.REQUIRED_FIELDS]: {},
  [Features.TECHNICAL_SUPPORT]: {},
  [Features.CONVERSATION_ROUTING]: {},
  [Features.STRIPE_INTEGRATION]: {},
  [Features.SALES_AUTOMATION]: {},
  [Features.TASK_QUEUES]: {},
  [Features.SIMPLE_AUTOMATION]: {},
  [Features.SALES_CONTENT_ANALYTICS]: {}
});
export const _salesProfessionalFeatureIds = Object.assign({}, _salesStarterFeatureIds, {
  [Features.PRESETS]: {},
  [Features.REP_PRODUCTIVITY_PERFORMANCE]: {},
  [Features.WORKFLOWS_EXTENSIONS]: {},
  [Features.SEQUENCES]: {},
  [Features.ESIGN]: {},
  [Features.AUTOMATIC_LEAD_ROTATION]: {},
  [Features.SMART_SEND_TIMES]: {},
  [Features.REQUIRED_FIELDS]: {},
  [Features.CUSTOM_REPORTS]: {},
  [Features.VIDEO_CREATION]: {},
  [Features.STANDARD_CONTACT_SCORING]: {},
  [Features.TEAMS]: {},
  [Features.PRODUCTS]: {},
  [Features.CALCULATED_PROPERTIES]: {},
  [Features.RECORD_CUSTOMIZATION]: {},
  [Features.TARGET_ACCOUNTS_HOME]: {},
  [Features.COMPANY_SCORING]: {},
  [Features.FORECASTING]: {},
  [Features.ACCOUNT_OVERVIEW]: {},
  [Features.SALES_ANALYTICS]: {},
  [Features.LOGGED_IN_VISITOR_IDENTIFICATION]: {},
  [Features.ABM_TOOLS_AND_AUTOMATION]: {},
  [Features.SALESFORCE_INTEGRATION]: {},
  [Features.DUPLICATE_MANAGEMENT]: {},
  [Features.PERMISSION_SETS]: {},
  [Features.ASSOCIATION_LABELS]: {},
  [Features.PLAYBOOKS]: {},
  [Features.CALL_TRANSCRIPTION_AND_COACHING]: {},
  [Features.CUSTOM_VIEWS_SHARED_INBOX]: {},
  [Features.TASK_CALENDAR_SYNC]: {}
});
export const _salesEnterpriseFeatureIds = Object.assign({}, _salesProfessionalFeatureIds, {
  [Features.SALESFORCE_CUSTOM_OBJECT_SYNC]: {},
  [Features.CUSTOM_OBJECTS]: {},
  [Features.HIERARCHICAL_TEAMS]: {},
  [Features.PREDICTIVE_LEAD_SCORING]: {},
  [Features.SINGLE_SIGN_ON]: {},
  [Features.GOALS]: {},
  [Features.RECURRING_REVENUE_TRACKING]: {},
  [Features.FIELD_LEVEL_PERMISSIONS]: {},
  [Features.CONVERSATION_INTELLIGENCE]: {},
  [Features.ADMIN_NOTIFICATIONS_MANAGEMENT]: {},
  [Features.SANDBOXES]: {},
  [Features.LOGIN_AS_ANOTHER_USER]: {},
  [Features.ADVANCED_PERMISSIONS]: {},
  [Features.CUSTOM_GOALS]: {},
  [Features.DEAL_SPLITS]: {}
});
export const _serviceFreeFeatureIds = {
  [Features.ALL_CRM_FEATURES]: {},
  [Features.TICKETING]: {},
  [Features.CALLING_SDK]: {},
  [Features.EMAIL_SCHEDULING]: {},
  [Features.LIVE_CHAT]: {},
  [Features.CONVERSATIONS_INBOX]: {},
  [Features.CONVERSATIONAL_BOTS]: {},
  [Features.TEAM_EMAIL]: {},
  [Features.SNIPPETS]: {},
  [Features.TEMPLATES]: {},
  [Features.MEETINGS]: {},
  [Features.REPORTING_DASHBOARDS]: {},
  [Features.EMAIL_TRACKING_NOTIFICATIONS]: {},
  [Features.DOCUMENTS]: {},
  [Features.MESSENGER_INTEGRATION]: {},
  [Features.CUSTOM_PROPERTIES]: {},
  [Features.MOBILE_APP]: {},
  [Features.MULTIPLE_TICKET_PIPELINES]: {},
  [Features.MARKETING_EVENTS_OBJECT]: {},
  [Features.EMAIL_REPLY_TRACKING]: {},
  [Features.EMAIL_HEALTH_REPORTING]: {},
  [Features.ONE_TO_ONE_EMAIL]: {},
  [Features.CHANNEL_SWITCHING]: {},
  [Features.USER_MANAGEMENT]: {},
  [Features.CUSTOM_USER_PERMISSIONS]: {},
  [Features.MOBILE_INBOX]: {},
  [Features.SLACK]: {},
  [Features.LIST_SEGMENTATION]: {}
};
export const _serviceStarterFeatureIds = Object.assign({}, _serviceFreeFeatureIds, {
  [Features.HS_PHONE_NUMBERS]: {},
  [Features.CALLING]: {},
  [Features.CONVERSATION_ROUTING]: {},
  [Features.MULTI_CURRENCY]: {},
  [Features.SIMPLE_TICKET_AUTOMATION]: {},
  [Features.TASK_QUEUES]: {},
  [Features.REQUIRED_FIELDS]: {},
  [Features.TECHNICAL_SUPPORT]: {},
  [Features.PAYMENTS]: {},
  [Features.EMAIL_SUPPORT]: {}
});
export const _serviceProfessionalFeatureIds = Object.assign({}, _serviceStarterFeatureIds, {
  [Features.PRESETS]: {},
  [Features.SEQUENCES]: {},
  [Features.KNOWLEDGE_BASE]: {},
  [Features.VIDEO_CREATION]: {},
  [Features.INSIGHTS_DASHBOARD]: {},
  [Features.AGENT_PRESENCE]: {},
  [Features.PRODUCTS]: {},
  [Features.CUSTOM_REPORTS]: {},
  [Features.TICKET_ROUTING]: {},
  [Features.TEAMS]: {},
  [Features.STANDARD_CONTACT_SCORING]: {},
  [Features.CUSTOMER_SERVICE_AUTOMATION]: {},
  [Features.GOALS]: {},
  [Features.CALCULATED_PROPERTIES]: {},
  [Features.RECORD_CUSTOMIZATION]: {},
  [Features.VIDEO_HOSTING_MANAGEMENT]: {},
  [Features.FORECASTING]: {},
  [Features.LOGGED_IN_VISITOR_IDENTIFICATION]: {},
  [Features.MULTI_LANGUAGE_KNOWLEDGE_BASE]: {},
  [Features.SALESFORCE_INTEGRATION]: {},
  [Features.KNOWLEDGE_BASE_SINGLE_SIGN_ON]: {},
  [Features.CUSTOMER_FEEDBACK_SURVEYS]: {},
  [Features.CUSTOM_SURVEYS]: {},
  [Features.DUPLICATE_MANAGEMENT]: {},
  [Features.PERMISSION_SETS]: {},
  [Features.CUSTOMER_PORTAL]: {},
  [Features.POST_CHAT_FEEDBACK]: {},
  [Features.CUSTOM_VIEWS_SHARED_INBOX]: {},
  [Features.SLAS]: {},
  [Features.SERVICE_ANALYTICS]: {},
  [Features.ASSOCIATION_LABELS]: {},
  [Features.PLAYBOOKS]: {},
  [Features.CALL_TRANSCRIPTION_AND_COACHING]: {},
  [Features.WHATS_APP_INTEGRATION]: {},
  [Features.TASK_CALENDAR_SYNC]: {}
});
export const _serviceEnterpriseFeatureIds = Object.assign({}, _serviceProfessionalFeatureIds, {
  [Features.SINGLE_SIGN_ON]: {},
  [Features.SALESFORCE_CUSTOM_OBJECT_SYNC]: {},
  [Features.CUSTOM_OBJECTS]: {},
  [Features.HIERARCHICAL_TEAMS]: {},
  [Features.FIELD_LEVEL_PERMISSIONS]: {},
  [Features.CONVERSATION_INTELLIGENCE]: {},
  [Features.RECURRING_REVENUE_TRACKING]: {},
  [Features.ADMIN_NOTIFICATIONS_MANAGEMENT]: {},
  [Features.SANDBOXES]: {},
  [Features.LOGIN_AS_ANOTHER_USER]: {},
  [Features.CUSTOM_GOALS]: {}
});
export const _cmsFreeFeatureIds = {
  [Features.ALL_CRM_FEATURES]: {},
  [Features.DRAG_AND_DROP_EDITOR]: {},
  [Features.MOBILE_OPTIMIZATION]: {},
  [Features.BLOG]: {},
  [Features.SSL_CERTIFICATE]: {},
  [Features.WEBSITE_PAGES]: {},
  [Features.DESIGN_MANAGER]: {},
  [Features.CUSTOM_DOMAINS]: {},
  [Features.SUBDOMAIN_AND_COUNTRY_CODE_TLD]: {},
  [Features.CDN]: {},
  [Features.BUILT_IN_AMP_SUPPORT]: {},
  [Features.WEBSITE_THEMES]: {},
  [Features.LOCAL_WEBSITE_DEVELOPMENT]: {},
  [Features.ADVANCED_MENUS]: {},
  [Features.MULTI_LANGUAGE_CREATION_TESTING]: {},
  [Features.SITE_EXPORT]: {},
  [Features.BLOG_IMPORT]: {},
  [Features.WEBSITE_TRAFFIC_ANALYTICS]: {},
  [Features.WEB_APPLICATION_FIREWALL]: {},
  [Features.PREMIUM_HOSTING]: {},
  [Features.WEBSITE_STRUCTURE_IMPORT]: {},
  [Features.APP_AND_ASSET_MARKETPLACE]: {},
  [Features.TWENTY_FOUR_SEVEN_SECURITY_MONITORING]: {},
  [Features.CUSTOM_DOMAIN_SECURITY_SETTINGS]: {},
  [Features.SEO_RECOMMEND_OPTIMIZE]: {},
  [Features.LANDING_PAGES]: {},
  [Features.AUTO_GENERATED_XML_SITEMAP]: {},
  [Features.APEX_HOSTING_AND_REDIRECTS]: {},
  [Features.LIST_SEGMENTATION]: {},
  [Features.BLOG_EXPORT]: {},
  [Features.UPTIME]: {},
  [Features.MESSENGER_INTEGRATION]: {},
  [Features.MOBILE_APP]: {},
  [Features.REPORTING_DASHBOARDS]: {},
  [Features.EMAIL_MARKETING]: {},
  [Features.CONVERSATIONAL_BOTS]: {},
  [Features.AD_MANAGEMENT]: {},
  [Features.LIVE_CHAT]: {},
  [Features.FORMS]: {},
  [Features.CONVERSATIONS_INBOX]: {}
};
export const _cmsStarterFeatureIds = Object.assign({}, _cmsFreeFeatureIds, {
  [Features.URL_MAPPINGS]: {},
  [Features.TECHNICAL_SUPPORT]: {},
  [Features.MULTI_CURRENCY]: {},
  [Features.PAYMENTS]: {},
  [Features.REQUIRED_FIELDS]: {},
  [Features.PERSONALIZATION_TOKENS]: {}
});
export const _cmsProfessionalFeatureIds = Object.assign({}, _cmsStarterFeatureIds, {
  [Features.PRESETS]: {},
  [Features.CALLS_TO_ACTION]: {},
  [Features.DYNAMIC_PERSONALIZATION]: {},
  [Features.RECORD_CUSTOMIZATION]: {},
  [Features.STANDARD_CONTACT_SCORING]: {},
  [Features.CALCULATED_PROPERTIES]: {},
  [Features.ATTRIBUTION_REPORTING]: {},
  [Features.CONTENT_STAGING]: {},
  [Features.GOOGLE_SEARCH_CONSOLE_INTEGRATION]: {},
  [Features.PRODUCTS]: {},
  [Features.VIDEO_HOSTING_MANAGEMENT]: {},
  [Features.PASSWORD_PROTECTED_PAGES]: {},
  [Features.CONTENT_STRATEGY]: {},
  [Features.AB_TESTING]: {},
  [Features.CUSTOM_REPORTS]: {},
  [Features.TEAMS]: {},
  [Features.FILTERED_ANALYTICS_VIEW]: {},
  [Features.LOGGED_IN_VISITOR_IDENTIFICATION]: {},
  [Features.SALESFORCE_INTEGRATION]: {},
  [Features.SITE_TREE]: {},
  [Features.DUPLICATE_MANAGEMENT]: {},
  [Features.PERMISSION_SETS]: {},
  [Features.ASSOCIATION_LABELS]: {},
  [Features.SMART_CONTENT_AND_REPORTING]: {},
  [Features.HUB_DB_DYNAMIC_CONTENT]: {},
  [Features.CUSTOM_VIEWS_SHARED_INBOX]: {},
  [Features.SEO_ANALYTICS]: {}
});
export const _cmsEnterpriseFeatureIds = Object.assign({}, _cmsProfessionalFeatureIds, {
  [Features.CUSTOM_OBJECTS]: {},
  [Features.SALESFORCE_CUSTOM_OBJECT_SYNC]: {},
  [Features.ADAPTIVE_TESTING]: {},
  [Features.MEMBERSHIPS]: {},
  [Features.ADDITIONAL_ROOT_DOMAINS]: {},
  [Features.CODE_ALERTS]: {},
  [Features.CONTENT_PARTITIONING]: {},
  [Features.REVERSE_PROXY_CONFIGURATION]: {},
  [Features.SITE_PERFORMANCE_MONITORING]: {},
  [Features.ACTIVITY_LOGGING]: {},
  [Features.SINGLE_SIGN_ON]: {},
  [Features.HIERARCHICAL_TEAMS]: {},
  [Features.WEB_APPS]: {},
  [Features.FIELD_LEVEL_PERMISSIONS]: {},
  [Features.ADMIN_NOTIFICATIONS_MANAGEMENT]: {},
  [Features.SANDBOXES]: {},
  [Features.LOGIN_AS_ANOTHER_USER]: {}
});
export const _operationsFreeFeatureIds = {
  [Features.DATA_SYNC]: {},
  [Features.HISTORICAL_SYNC]: {},
  [Features.DEFAULT_FIELD_MAPPINGS]: {},
  [Features.COMPANIES]: {},
  [Features.DEALS]: {},
  [Features.APP_MARKETPLACE_INTEGRATIONS]: {},
  [Features.CONTACT_MANAGEMENT]: {},
  [Features.TICKETING]: {},
  [Features.TASKS_AND_ACTIVITIES]: {},
  [Features.COMPANY_INSIGHTS]: {},
  [Features.CUSTOM_PROPERTIES]: {},
  [Features.MARKETING_EVENTS_OBJECT]: {},
  [Features.EMAIL_REPLY_TRACKING]: {},
  [Features.EMAIL_HEALTH_REPORTING]: {},
  [Features.USER_MANAGEMENT]: {},
  [Features.CUSTOM_USER_PERMISSIONS]: {},
  [Features.LIST_SEGMENTATION]: {}
};
export const _operationsStarterFeatureIds = Object.assign({}, _operationsFreeFeatureIds, {
  [Features.CUSTOM_FIELD_MAPPINGS]: {},
  [Features.TECHNICAL_SUPPORT]: {},
  [Features.PAYMENTS]: {},
  [Features.REQUIRED_FIELDS]: {}
});
export const _operationsProfessionalFeatureIds = Object.assign({}, _operationsStarterFeatureIds, {
  [Features.PRESETS]: {},
  [Features.PROGRAMMABLE_AUTOMATION]: {},
  [Features.WEBHOOKS]: {},
  [Features.DATA_QUALITY_AUTOMATION]: {},
  [Features.BULK_DUPLICATE_MANAGEMENT]: {},
  [Features.REQUIRED_FIELDS]: {},
  [Features.RECORD_CUSTOMIZATION]: {},
  [Features.STANDARD_CONTACT_SCORING]: {},
  [Features.COMPANY_SCORING]: {},
  [Features.PERMISSION_SETS]: {},
  [Features.SCHEDULED_WORKFLOW_TRIGGERS]: {},
  [Features.PRODUCTS]: {},
  [Features.ASSOCIATION_LABELS]: {},
  [Features.CALCULATED_PROPERTIES]: {},
  [Features.CUSTOM_REPORTS]: {},
  [Features.DATA_QUALITY_COMMAND_CENTER]: {},
  [Features.DATA_HEALTH_TRENDS]: {},
  [Features.AI_POWERED_DATA_FORMATTING_RECOMMENDATIONS]: {}
});
export const _operationsEnterpriseFeatureIds = Object.assign({}, _operationsProfessionalFeatureIds, {
  [Features.CUSTOM_OBJECTS]: {},
  [Features.ADVANCED_DATA_CALCULATIONS]: {},
  [Features.SNOWFLAKE_DATA_SHARE]: {},
  [Features.SALESFORCE_CUSTOM_OBJECT_SYNC]: {},
  [Features.SANDBOXES]: {},
  [Features.SINGLE_SIGN_ON]: {},
  [Features.FIELD_LEVEL_PERMISSIONS]: {},
  [Features.ADMIN_NOTIFICATIONS_MANAGEMENT]: {},
  [Features.LOGIN_AS_ANOTHER_USER]: {},
  [Features.ADVANCED_PERMISSIONS]: {},
  [Features.DATASETS]: {}
});